import React from 'react'

import { Field } from 'formik'

import { Button, Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import { TipoCambioModal } from 'sharedComponents/modals'

import { KeyEventUtil } from 'utils'

import * as TiposCambioService from 'services/tiposCambio.service'

const TipoCambioFormGroup = ({
  iError,
  iTouched,
  iMoneda,
  iValue,
  iFechaDocumento,
  setFieldValue,
  fIsSubmitting
}) => {
  const [mostrarModal, setMostrarModal] = React.useState(false)

  const consultarTipoCambio = React.useCallback(() => {
    TiposCambioService.getxFechaxMonedaxTipoCambio(iFechaDocumento, iMoneda, 'VENT').then(
      ({ data }) => {
        setFieldValue('tipoCambio', data.tipoCambio || 0)
      }
    )
  }, [iMoneda, iFechaDocumento, setFieldValue])

  React.useEffect(() => {
    if (iFechaDocumento && iMoneda && iValue === 1) {
      if (iMoneda === MonedasConstant.SOLES) {
        setFieldValue('tipoCambio', 1)
      } else {
        consultarTipoCambio()
      }
    }
  }, [iMoneda, iFechaDocumento, setFieldValue, consultarTipoCambio, iValue])

  const clickTiposCambio = React.useCallback(() => {
    setMostrarModal(true)
  }, [])

  const handleCloseModal = React.useCallback(() => {
    setMostrarModal(false)
    consultarTipoCambio()
  }, [consultarTipoCambio])

  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('select-modalavanz-glosa', e)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='T/C' htmlFor={`input-modalavanz-tipoCambio`} md={12} />
        <Col md={12}>
          <Form.InputGroup>
            <Field name='tipoCambio'>
              {({ field }) => (
                <Form.InputNumber
                  {...field}
                  id={`input-modalavanz-tipoCambio`}
                  disabled={fIsSubmitting}
                  isInvalid={iTouched && iError}
                  onKeyDown={onKeyDown}
                />
              )}
            </Field>
            <Form.InputGroup.Append>
              <Button onClick={clickTiposCambio}>O</Button>
            </Form.InputGroup.Append>
          </Form.InputGroup>
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
      {mostrarModal && <TipoCambioModal show={mostrarModal} handleClose={handleCloseModal} />}
    </>
  )
}

export default React.memo(TipoCambioFormGroup)
